import { useEffect, useState } from "react";
import { ADMIN_REALTIME_BROWSER_EVENT } from "../realtime/adminRealtimeClient";

export default function useAdminRealtimeTick() {
	const [tick, setTick] = useState(0);

	useEffect(() => {
		const handleRealtime = () => {
			setTick((prev) => prev + 1);
		};

		window.addEventListener(ADMIN_REALTIME_BROWSER_EVENT, handleRealtime);

		return () => {
			window.removeEventListener(ADMIN_REALTIME_BROWSER_EVENT, handleRealtime);
		};
	}, []);

	return tick;
}
